import { LegalLayout, CLINIC } from "../components/LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Política de Privacidad y Protección de Datos">
      <p>
        En cumplimiento del Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de
        Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD), se informa al usuario
        del tratamiento de sus datos personales.
      </p>

      <h2>1. Responsable del tratamiento</h2>
      <ul>
        <li><strong>Responsable:</strong> Dr. Dimy Laguerre (Nº Colegiado {CLINIC.colegiado})</li>
        <li><strong>Dirección:</strong> {CLINIC.address}</li>
        <li><strong>Email DPO/Contacto:</strong> {CLINIC.email}</li>
      </ul>

      <h2>2. Categorías de datos tratados</h2>
      <p>Tratamos las siguientes categorías de datos:</p>
      <ul>
        <li><strong>Identificativos:</strong> nombre, apellidos, DNI/NIE, fecha de nacimiento.</li>
        <li><strong>Contacto:</strong> email, teléfono, dirección postal.</li>
        <li><strong>Datos de salud</strong> (categoría especial, Art. 9 RGPD): historia clínica, diagnósticos,
        medicación prescrita, resultados de pruebas, alergias, antecedentes.</li>
        <li><strong>Económicos:</strong> datos de pago procesados por Stripe (no almacenamos números de tarjeta).</li>
        <li><strong>Técnicos:</strong> dirección IP, navegador, fecha y hora de acceso (logs de auditoría).</li>
      </ul>

      <h2>3. Finalidades del tratamiento</h2>
      <ul>
        <li>Prestación del servicio sanitario solicitado (consultas, recetas, peticiones de pruebas).</li>
        <li>Gestión de citas y recordatorios.</li>
        <li>Cumplimiento de obligaciones legales (Ley 41/2002 de autonomía del paciente, conservación de
        historia clínica).</li>
        <li>Facturación y gestión de cobros.</li>
        <li>Comunicaciones relacionadas con el servicio (confirmaciones, recordatorios, resúmenes
        post-consulta).</li>
        <li>Auditoría y seguridad del sistema.</li>
      </ul>

      <h2>4. Base jurídica del tratamiento</h2>
      <ul>
        <li><strong>Ejecución del contrato sanitario</strong> (Art. 6.1.b RGPD) para citas y servicios.</li>
        <li><strong>Consentimiento explícito</strong> (Art. 9.2.a RGPD) para tratamiento de datos de salud.</li>
        <li><strong>Obligación legal</strong> (Art. 6.1.c RGPD) para conservación de historia clínica
        conforme a Ley 41/2002.</li>
        <li><strong>Interés vital</strong> (Art. 9.2.c RGPD) en urgencias médicas.</li>
      </ul>

      <h2>5. Plazo de conservación</h2>
      <p>Los datos sanitarios se conservarán durante un mínimo de <strong>5 años</strong> y un máximo de
      <strong> 15 años</strong> desde la última asistencia, conforme al Art. 17 de la Ley 41/2002. Los datos
      económicos y fiscales se conservarán durante 6 años (Ley General Tributaria). Tras estos plazos, los
      datos serán anonimizados o suprimidos.</p>

      <h2>6. Destinatarios y encargados del tratamiento</h2>
      <p>Sus datos pueden ser comunicados a:</p>
      <ul>
        <li><strong>Stripe Inc.</strong> (procesamiento de pagos, encargado del tratamiento) — datos
        económicos.</li>
        <li><strong>Wise Payments Ltd.</strong> (procesamiento de pagos alternativo) — datos económicos.</li>
        <li><strong>Resend Inc.</strong> (envío de emails transaccionales) — email y nombre.</li>
        <li><strong>Jitsi (8x8 Inc.)</strong> (proveedor de videoconsulta) — nombre y email durante la
        sesión.</li>
        <li><strong>Anthropic PBC / Emergent Labs</strong> (asistente de IA en chat) — texto del chat sin
        identificadores personales cuando sea posible.</li>
        <li><strong>Administraciones públicas sanitarias</strong> cuando exista obligación legal (REMPE,
        Consejería de Salud).</li>
      </ul>

      <h2>7. Transferencias internacionales</h2>
      <p>Algunos encargados del tratamiento están ubicados en EE. UU. Las transferencias se realizan con
      garantías adecuadas conforme al Art. 46 RGPD: Cláusulas Contractuales Tipo (SCC) y/o adhesión al
      <em> EU-U.S. Data Privacy Framework</em>.</p>

      <h2>8. Derechos del usuario</h2>
      <p>Puede ejercer en cualquier momento los siguientes derechos:</p>
      <ul>
        <li><strong>Acceso</strong>: obtener confirmación y copia de sus datos.</li>
        <li><strong>Rectificación</strong>: corregir datos inexactos.</li>
        <li><strong>Supresión / "Derecho al olvido"</strong>: limitado por la obligación legal de
        conservación de historia clínica.</li>
        <li><strong>Limitación</strong> del tratamiento.</li>
        <li><strong>Portabilidad</strong> de datos en formato estructurado.</li>
        <li><strong>Oposición</strong> al tratamiento.</li>
        <li><strong>No ser objeto de decisiones automatizadas</strong> con efectos jurídicos.</li>
      </ul>
      <p>Para ejercerlos: enviar email a <strong>{CLINIC.email}</strong> identificándose adecuadamente, o
      desde la sección "Mi perfil" → "Mis datos y privacidad" dentro de la aplicación.</p>

      <h2>9. Reclamaciones ante la autoridad de control</h2>
      <p>Si considera vulnerados sus derechos, puede presentar reclamación ante la <strong>Agencia Española
      de Protección de Datos (AEPD)</strong>: <a href="https://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a></p>

      <h2>10. Medidas de seguridad</h2>
      <p>Aplicamos medidas técnicas y organizativas para proteger los datos: cifrado en tránsito (HTTPS/TLS),
      contraseñas hasheadas con bcrypt, autenticación con tokens JWT, logs de auditoría de acceso a datos
      sanitarios, control de acceso por roles, copias de seguridad cifradas.</p>

      <h2>11. Inteligencia artificial</h2>
      <p>La aplicación utiliza un asistente de IA (Claude, de Anthropic) en el chat médico público. Conforme
      al Reglamento (UE) 2024/1689 sobre IA, se informa que:</p>
      <ul>
        <li>El asistente IA <strong>NO</strong> realiza diagnósticos clínicos.</li>
        <li>Sus respuestas son <strong>orientativas</strong> y no sustituyen la consulta médica
        profesional.</li>
        <li>Toda decisión clínica es tomada por un profesional sanitario colegiado.</li>
      </ul>
    </LegalLayout>
  );
}
